const ErrorMessages = {
    required: 'Required!',
    min: 'Must be at least ${min} characters!',
    max: 'Must be ${max} characters at most!',
    email: 'It must be a valid email address!',
    passwordConfirmation: 'It must be the same as Password!',
}

export default ErrorMessages
